module.exports = __webpack_public_path__ + "media/images/talent/case05-badge-ef92d30da2e5c601dbff8fede7e4d048.png";